export default 'https://tme.understood.org/assets/spider_spiral.cdcca1d5.jpg'